import { render, staticRenderFns } from "./ProgramsSingleGraduatesCoordinatorListItem.vue?vue&type=template&id=52352f3e&"
import script from "./ProgramsSingleGraduatesCoordinatorListItem.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleGraduatesCoordinatorListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports